window.Reverb = window.Reverb || {};
Reverb.TaxForm = Reverb.TaxForm || {};

Reverb.TaxForm.TaxID = (function () {
  const SSNSelector = '[data-ssn-inputmask]';
  const taxIDSelector = '[data-tax-id-inputmask]';

  function registerCustomMask() {
    $.inputmask.defaults.definitions['x'] = {
      validator: '[0-9X]',
      definitionSymbol: '*',
      cardinality: 1,
    }
  }

  function addSSNInputMask() {
    $(SSNSelector).inputmask('xxx-xx-xxxx', { placeholder: ' ', showMaskOnHover: false, showMaskOnFocus: false });
  }

  function addTaxIDInputMask() {
    $(taxIDSelector).inputmask('xx-xxxxxxx', { placeholder: ' ', showMaskOnHover: false, showMaskOnfocus: false });
  }

  function init() {
    registerCustomMask()
    addSSNInputMask();
    addTaxIDInputMask();
  }

  return {
    init,
  };
}());

$(Reverb.TaxForm.TaxID.init);
